export default __webpack_public_path__ + "static/media/listbuilder-trophy-selected.8dec3b48.svg";